import { useQuery } from '@tanstack/react-query';
import Api from 'hooks/Api';
import { AccountCard, Meta } from 'utils/types';
import { useProvider } from 'utils/providers/Provider';

interface Result {
  data: AccountCard;
  meta: Meta;
}

export default function useGetAccountCard(id: string) {
  const { state } = useProvider();
  const args = state;
  return useQuery<AccountCard, Error>({
    queryFn: async () => {
      const api = new Api(args);

      const { data }: Result = await api.get({
        url: `api/public/accounts/cards/${id}`,
      });

      return data;
    },
    enabled: !!id,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
